import type { XMODCategoryMode, XMODComponentType } from 'src/types/xmod';

/**
 * Maps a single XMOD component type to the normalized `{ category, mode }` pair
 * used by the Shelly app.
 *
 * The mapping is intentionally centralized so that:
 * - device extraction/helpers can classify channels consistently
 * - config helpers can derive device mode without duplicating logic.
 */
export const mapXMODComponentToCategoryAndMode = (
	componentType: XMODComponentType,
): XMODCategoryMode => {
	switch (componentType) {
		case 'cct':
			return { category: 'light', mode: 'cct' };
		case 'rgbw':
			return { category: 'light', mode: 'rgbw' };
		case 'light':
			return { category: 'light', mode: 'light' };
		case 'switch':
			return { category: 'relay', mode: 'relay' };
		case 'input':
			return { category: 'inputs_reader', mode: 'inputs_reader' };
		default:
			return { category: 'module', mode: 'shell' };
	}
};
